import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles((t: typeof theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
  },

  error: {
    color: t.red01,
  },

  marginTop: {
    marginTop: '1rem',
  },

  centerButton: {
    display: 'flex',
    justifyContent: 'center',
  },

  centerText: {
    textAlign: 'center',
  },
}))
